import { defineMessages } from "react-intl";

export const messages = defineMessages( {
	showPaymentMethod: {
		id: "subscriptionPage.paymentMethod.showButton",
		defaultMessage: "Show payment method",
	},
	fetching: {
		id: "subscriptionPage.paymentMethod.fetching",
		defaultMessage: "Fetching...",
	},
	retry: {
		id: "subscriptionPage.paymentMethod.retry",
		defaultMessage: "Retry",
	},
	genericError: {
		id: "subscriptionPage.paymentMethod.genericError",
		defaultMessage: "Unable to retrieve payment information at this time. Please try again later.",
	},
	noPaymentMethod: {
		id: "subscriptionPage.paymentMethod.noPaymentMethod",
		defaultMessage: "No payment information known",
	},
} );
